import React, { useCallback, useState } from 'react';
import { CustomTextField } from 'components';
import { InputAdornment } from '@mui/material';
import { Eye, EyeOff } from 'mdi-material-ui';

const PasswordField = ({ label, value, onChange, error, ...rest }) => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const togglePasswordVisibility = useCallback(
        () => setPasswordVisible(prevState => !prevState),
        []
    );
    return (
        <CustomTextField
            label={label}
            type={passwordVisible ? 'text' : 'password'}
            value={value}
            onChange={onChange}
            error={error}
            endAdornment={
                <InputAdornment
                    sx={{
                        color: 'grey.500',
                        '&:hover': {
                            color: 'primary.main',
                            cursor: 'pointer',
                        },
                    }}
                    onClick={togglePasswordVisibility}
                    position="start"
                >
                    {passwordVisible ? <EyeOff fontSize="small" /> : <Eye fontSize="small" />}
                </InputAdornment>
            }
            {...rest}
        />
    );
};

export default PasswordField;
